import moment from 'moment';

export const DateFullDay = (date, locale = "en") => {
    moment.locale(locale);
    return moment(date).format('MMMM Do YYYY, h:mm:ss a');
}